var RingGraphGeneralGoModelToDataConverter = /** @class */ (function () {
    function RingGraphGeneralGoModelToDataConverter(data) {
        this.rotationDirection = data.rotationDirection;
        this._isFullRing = data.isFullRing;
        this._startAngle = data.startAngle;
        this._endAngle = data.endAngle;
        this._radiusPercentage = data.radiusPercentage;
        this._minCalibration = data.minCalibration;
        this._maxCalibration = data.maxCalibration;
        this._variableId = {
            dataSourceCode: data.dataSourceCode ? data.dataSourceCode : 0,
            variableName: {
                name: data.variableName,
                groupName: data.variableGroupName
            }
        };
        this._configureVariableId = {
            name: data.variableName,
            variableVersion: data.variableVersion ? data.variableVersion : undefined
        };
    }
    Object.defineProperty(RingGraphGeneralGoModelToDataConverter.prototype, "rotationDirection", {
        get: function () {
            return this._rotationDirection;
        },
        set: function (v) {
            this._rotationDirection = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RingGraphGeneralGoModelToDataConverter.prototype, "isFullRing", {
        get: function () {
            return this._isFullRing;
        },
        set: function (v) {
            this._isFullRing = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RingGraphGeneralGoModelToDataConverter.prototype, "startAngle", {
        get: function () {
            return this._startAngle;
        },
        set: function (v) {
            this._startAngle = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RingGraphGeneralGoModelToDataConverter.prototype, "endAngle", {
        get: function () {
            return this._endAngle;
        },
        set: function (v) {
            this._endAngle = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RingGraphGeneralGoModelToDataConverter.prototype, "radiusPercentage", {
        get: function () {
            return this._radiusPercentage;
        },
        set: function (v) {
            this._radiusPercentage = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RingGraphGeneralGoModelToDataConverter.prototype, "minCalibration", {
        get: function () {
            return this._minCalibration;
        },
        set: function (v) {
            this._minCalibration = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RingGraphGeneralGoModelToDataConverter.prototype, "maxCalibration", {
        get: function () {
            return this._maxCalibration;
        },
        set: function (v) {
            this._maxCalibration = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RingGraphGeneralGoModelToDataConverter.prototype, "variableId", {
        get: function () {
            return this._variableId;
        },
        set: function (v) {
            this._variableId = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RingGraphGeneralGoModelToDataConverter.prototype, "configureVariableId", {
        get: function () {
            return this._configureVariableId;
        },
        set: function (v) {
            this._configureVariableId = v;
        },
        enumerable: true,
        configurable: true
    });
    return RingGraphGeneralGoModelToDataConverter;
}());
export { RingGraphGeneralGoModelToDataConverter };
